@for (item of placeholderArray; track item) {
  <app-summary-report-tile [isPlaceholder]="true"></app-summary-report-tile>
}
